
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/is/for-artists",
      function () {
        return require("private-next-pages/is/for-artists.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/is/for-artists"])
      });
    }
  